module.exports = __webpack_public_path__ + "static/media/Block_Party_Poster.944ab2fb.jpg";